/**
 * The in-app micro survey: a one-question prompt shown to eligible members,
 * with its own endpoint and analytics, unrelated to the survey definitions in
 * `features/surveys`.
 */
export { MicroSurveyPopup } from './ui/MicroSurveyPopup';
